export default __webpack_public_path__ + "static/media/frog-mat.abdb4187.svg";